import Image from 'next/image';
import { FC } from 'react';
import { getHtmlTags } from 'src/functions/getHtmlTags';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import NGText from 'src/styles/theme/components/NGText';
import { EFontStyle, ETextAlign } from 'src/styles/theme/components/NGText/NGText.enum';
import { EMediaQuery, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { StyledAvatar } from './Quote.styles';
import { IQuotes } from './Quote.type';

const Quote: FC<IQuotes> = ({ img, quote, quoteAuthor }) => {
	return (
		<Flex direction={EFlex.column} fullWidth>
			<Flex
				direction={EFlex.row}
				vertical={EFlex.center}
				horizontal={EFlex.start}
				marginY={ESize['xs']}
				xsMarginBottom={ESize.unset}
				paddingRight={ESize['2xs']}
			>
				{img ? (
					<StyledAvatar>
						<Image quality={100} src={img} alt={''} layout='fill' objectFit='cover' draggable={false} />
					</StyledAvatar>
				) : null}

				<Flex direction={EFlex.column} width={!!img ? 8 / 12 : '100%'} marginLeft={ESize['2xs']}>
					<NGText
						textAlign={ETextAlign.left}
						textColor={ETextColor.white}
						fontStyle={EFontStyle.italic}
						size={ESize.l}
						className='quote'
					>
						{getHtmlTags(quote)}
					</NGText>
					<NGText
						hiddenRange={!!img ? [EMediaQuery.xs, undefined] : undefined}
						textColor={ETextColor.white}
						fontStyle={EFontStyle.italic}
						textAlign={ETextAlign.right}
						size={ESize.m}
						width='100%'
						marginTop={ESize['4xs']}
					>
						{quoteAuthor}
					</NGText>
				</Flex>
			</Flex>

			{!!img ? (
				<NGText
					hiddenRange={[undefined, EMediaQuery.xs]}
					textColor={ETextColor.white}
					fontStyle={EFontStyle.italic}
					textAlign={ETextAlign.right}
					size={ESize.m}
					width='100%'
					paddingRight={ESize['2xs']}
					xsMarginBottom={ESize.xs}
				>
					{quoteAuthor}
				</NGText>
			) : null}
		</Flex>
	);
};
export { Quote };
